module.exports = __webpack_public_path__ + "media/images/flags/64/Iran-3ca9eeba2febb60bd3f5294ed3cabb8f.png";